
import "./Diamond_Education.css";


const Diamond_Education = () => {
  return (
    <>
      <section className="Privacy_Policy Diamond_Education">
        <div className="bg_img_div">
          <div className="white_bg_div">
            <div className="container">
              <p className="section_title heading_text">Diamond Education</p>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="main_content_div theme_bg_primary_colour">
            <p className="dark_black_text">
              We truly believe ‘feel good jewelry’ should be feel good in every
              which way. Which is why our lab grown diamonds come with none of
              the ethical and sustainable concerns that natural diamonds come
              with. Quite literally guilt-free.
            </p>

            <p className="dark_black_text">THE NEXT GENERATION OF DIAMONDS </p>
            <p className="dark_black_text">
              Lab Grown Diamonds are authentic diamonds that are created with
              state-of-the-art science and technology, outside a mine and inside
              a lab. While science takes care of precision, a human touch goes
              further in the cutting and polishing of the stone, which is why
              our diamonds are also hand crafted, giving you the best of both
              worlds. In fact, lab diamonds are the only diamonds whose origin
              you can trace to the T. Which means they don’t just bring sparkle
              to your day, but to the earth and to human rights everywhere.
            </p>

            <div className="edu_img_holder">
              <img
                src="/assets/images/diamond_education/diamond.webp"
                className="edu_img"
              />
            </div>

            <p className="bold_text">Is it the same?</p>

            <p className="dark_black_text">
              Chemically and optically identical to natural diamonds, most
              jewelers are opting for lab diamonds, making them the go-to-stone
              of the present and future. In terms of certification and grading,
              lab diamonds go head-to-head with natural ones and come out
              indistinguishable in every which way. <br />
              And you’ll agree with us when we say your diamond shines better,
              when your conscience shines alongside with it. A contemporary
              diamond that is a sign of the times and will stand the test of
              time, just like you.
            </p>

            <p className="bold_text">
              IGI Explains what are labgrown diamonds.
            </p>
            <p className="dark_black_text mb-0">External Links:</p>
            <p className="link_text">https://youtu.be/fK-XWvVEISE</p>
          </div>
        </div>
      </section>
      {/* <Stay_Connected /> */}
    </>
  );
};

export default Diamond_Education;
